import * as React from "react";
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
var TableColumnsSkeleton = function (_a) {
    var columns = _a.columns;
    return (React.createElement(React.Fragment, null, Array.from({ length: columns }).map(function (__, number) { return (React.createElement(TableCell, { key: number },
        React.createElement(Skeleton, null))); })));
};
export var TableRowsSkeleton = function (_a) {
    var rows = _a.rows, columns = _a.columns;
    return (React.createElement(React.Fragment, null, Array.from({ length: rows }).map(function (_, index) { return (React.createElement(TableRow, { key: index },
        React.createElement(TableColumnsSkeleton, { columns: columns }))); })));
};
export var TableSkeleton = function (_a) {
    var rows = _a.rows, columns = _a.columns;
    return (React.createElement(TableContainer, { component: Paper },
        React.createElement(Table, null,
            React.createElement(TableHead, null,
                React.createElement(TableRow, null,
                    React.createElement(TableColumnsSkeleton, { columns: columns }))),
            React.createElement(TableBody, null,
                React.createElement(TableRowsSkeleton, { rows: rows, columns: columns })))));
};
